<template>
    <v-form @submit.prevent="submit" id="check-login-form">
        <v-content>
            <div class="mainflex">
                <v-card class="elevation-12 subdix">
                    <v-toolbar color="primary">
                        <v-toolbar-title class="toolbartitle">تسجيل الدخول</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="8">
                                <v-form v-model="valid" lazy-validation ref="form" id="new-form">
                                    <v-text-field
                                        outlined
                                        label="أسم المستخدم"
                                        name="email"
                                        v-model="email"
                                        @keyup.enter="validate()"
                                        :rules="[rules.required]"
                                        prepend-icon="mdi-account"
                                        type="text"
                                    ></v-text-field>

                                    <v-text-field
                                        outlined
                                        v-model="password"
                                        @keyup.enter="validate()"
                                        id="password"
                                        label="كلمة السر"
                                        :rules="[rules.required]"
                                        name="password"
                                        :type="'password'"
                                        prepend-icon="mdi-account-key"
                                    ></v-text-field>
                                </v-form>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-img :src="cphllogo" height="100" contain></v-img>
                                <div class="logotext">مختبر الصحة العامة المركزي</div>

                                <div class="logotext2">
                                    نظام معلومات غربلة الاطفال حديثي الولادة
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="showLoginError">
                            <v-col>
                                <v-alert color="red" type="error">
                                    خطأ في اسم المستخدم او كلمة السر
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            form="new-form"
                            @click="validate"
                            class="pa-4"
                            :disabled="disableLogin"
                            color="primary"
                        >
                            <v-icon class="ml-2">mdi-lock</v-icon>
                            <v-progress-circular
                                class="ml-2"
                                v-if="disableLogin"
                                color="black"
                                indeterminate
                                size="20"
                            />
                            تسجيل الدخول
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </v-content>
    </v-form>
</template>

<script>
import Axios from "axios";
export default {
    name: "login",
    data: function () {
        return {
            showLoginError: false,
            valid: true,
            cphllogo: "assets/cphl-logo.png",
            disableLogin: false,
            email: "",
            password: "",
            // Validation Rules
            rules: {
                required: value => !!value || "هذا الحقل مطلوب",
                counter: value => value.length <= 40 || "الحد الأقصى هو 40 حرف",
                phonecounter: value => {
                    const pattern = /^0?7[0-9]{9,9}$/;

                    return pattern.test(value) || "رقم الهاتف غير صحيح";
                },
                email: value => {
                    const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "البريد الالكتروني غير صحيح";
                },
                strength: value => {
                    const pattern =
                        /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/;
                    return (
                        pattern.test(value) ||
                        "يجب ان تكون كلمة السر مكونة حروف كبيرة، حروف صغيرة,ارقام , علامات خاصةو لاتقل عن ٦ ارقام او حروف"
                    );
                },
            },
        };
    },
    computed: {},
    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.submit();
            }
        },
        submit() {
            this.disableLogin = true;
            Axios.post(
                "https://cphl.esite-lab.com/api.php?do=login",
                {
                    username: this.email,
                    password: this.password,
                },
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then(res => {
                    if (res.status === 200) {
                        console.log(res.data);
                        localStorage.setItem("user_info", JSON.stringify(res.data.user));
                        localStorage.setItem("token", JSON.stringify(res.data.accessToken));
                        this.$store.dispatch("setLogin");
                        this.$store.dispatch("setLoginInfo", res.data.user);
                        this.$store.state.token = res.data.accessToken;
                        this.$router.push({ name: "home" });
                    } else {
                        this.showLoginError = true;
                        this.disableLogin = false;
                    }
                })
                .catch(() => {
                    this.showLoginError = true;
                    this.disableLogin = false;
                    localStorage.removeItem("user_info");
                    localStorage.removeItem("token");
                });
        },
    },
};
</script>
<style>
.toolbartitle {
    color: white !important;
}

.mainflex {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.subdix {
    margin-top: 20px;
    width: 50%;
}

.logotext {
    text-align: center;
    font-weight: bold;
    color: black;
    font-size: 1.2rem;
}

.logotext2 {
    text-align: center;
    font-weight: bold;
    color: black;
}

@media only screen and (max-width: 768px) {
    .subdix {
        margin-top: 20px;
        width: 96%;
    }
}
</style>
